export enum IotToolbarButtonType {
  MENU_BUTTON = 'MENU_BUTTON',
  REGULAR_BUTTON = 'REGULAR_BUTTON',
  TOGGLE_BUTTON = 'TOGGLE_BUTTON',
  STATUS_BUTTON = 'STATUS_BUTTON',
  DIVIDER = 'DIVIDER'
}
